import React, { forwardRef, ForwardRefRenderFunction, useEffect, useImperativeHandle, useState } from 'react'
import Trans from 'next-translate/Trans'
import useTranslation from 'next-translate/useTranslation'
import { Anchor, CheckboxProps } from '@mantine/core'
import { useClickOutside } from '@mantine/hooks'

import { CheckBoxWithTooltip } from 'components/ui'
import { useSignupFormContext } from '../formContext'
import { Privacy, Terms } from 'config/constants'

interface Props extends CheckboxProps {
  tooltipOpened?: boolean
}

export interface AgreementApi {
  setTooltipOpened: (value: boolean) => void
}

const Agreement: ForwardRefRenderFunction<AgreementApi, Props> = ({ size, ...rest }: Props, ref) => {
  const { t } = useTranslation('pageSignup')
  const form = useSignupFormContext()
  const [tooltipOpened, setTooltipOpened] = useState(false)
  const checkBoxRef = useClickOutside(() => setTooltipOpened(false))

  const agreed = form.values.agreement

  useEffect(() => {
    agreed && setTooltipOpened(false)
  }, [agreed])

  useImperativeHandle(ref, () => ({ setTooltipOpened }))

  const AgreementLabel = (
    <Trans
      i18nKey="pageSignup:agreement.title"
      components={{
        terms: <Anchor mx={4} size={size} href={Terms} target="_blank" />,
        privacy: <Anchor mx={4} size={size} href={Privacy} target="_blank" />,
      }}
    />
  )

  return (
    <CheckBoxWithTooltip
      ref={checkBoxRef}
      {...rest}
      tooltipLabel={t('pageSignup:agreement.tooltip')}
      tooltipOpened={tooltipOpened}
      label={AgreementLabel}
      {...form.getInputProps('agreement', { type: 'checkbox' })}
    />
  )
}

export default forwardRef(Agreement)
